import React, { FC, ReactNode } from 'react'

import { FIELD_PATH_LOOK_FOR } from 'components/page/DatingProfile/DatingProfile.constants'
import { sortGendersLgbtFeature45 } from 'components/page/Profile/function/sortGendersLgbtFeature45'
import { ProfileFieldType } from 'components/page/ProfileCommon/ProfileCommon.types'
import { ProfileFieldGeneric } from 'components/page/ProfileCommon/ProfileField/ProfileFieldGeneric'
import { GenderActiveSvg } from 'components/presentational/svg/GenderActiveSvg'
import {
  GQLDatingProfileLexicalOptionType,
  GQLGender,
  GQLLookFor,
} from 'generated-graphql/graphql'
import { useLgbtDetail } from 'hooks/useLgbtDetail'

import { useModifyLgbtLexemes } from './ProfileLookFor.useModifyLgbtLexemes'

export const ProfileLookFor: FC<{
  data: GQLLookFor[]
  gender: GQLGender
  lexemes: GQLDatingProfileLexicalOptionType[]
  description: ReactNode
}> = ({ data, gender, lexemes, description }) => {
  const { lgbtRestriction } = useLgbtDetail()
  const _lexemes = useModifyLgbtLexemes(lexemes, gender)

  return (
    <ProfileFieldGeneric
      iconActive={<GenderActiveSvg />}
      description={description}
      lexemes={_lexemes}
      data-name={FIELD_PATH_LOOK_FOR}
      fieldType={ProfileFieldType.WithTitle}
      data={lgbtRestriction ? sortGendersLgbtFeature45(data, gender) : data}
      showDescriptionIfActive={true}
    />
  )
}
